import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { ArrowLeftOutlined, CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Breadcrumb, Spin } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePreventRouteChange } from "../../../../../hooks/usePreventRouteChange";
import { getLearningMaterialDetail } from '../../../../../service/learning-material';
import CustomAudioPlayer from '../../../../learning-materials/components/view/AudioPlayer';
import ScormXapiViewer from '../../../../learning-materials/components/view/ScormXapiViewer';
import VideoPlayer from '../../../../learning-materials/components/view/VideoPlayer';
import "./LearningMaterialDetail.scss";
type Props = {
  viewDetail?: boolean
}

const LearningMaterialDetail = (props: Props) => {
  const { t } = useTranslation();
  const { id } = useParams()
  const [showInfo, setShowInfo] = useState(true);
  const [detail, setDetail] = useState<any>(null)
  const { confirmNavigation } = usePreventRouteChange();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const fetchLearningMaterialDetail = async () => {

      try {
        const res = await getLearningMaterialDetail(Number(id))
        setDetail(res?.data.data)
      } catch (error) {
      }
      finally {
        setLoading(false)
      }
    }
    fetchLearningMaterialDetail()
  }, [id])

  const RenderDetail = (type: string) => {
    switch (type) {
      case 'video':
        return (
          <div className="player-wrapper">
            <VideoPlayer url={detail?.rootKeyUrl || detail?.rootKey} />
          </div>
        );
      case 'pdf':
        return (
          <div className="player-wrapper">
            <iframe
              allow="fullscreen"
              scrolling="yes"
              src={detail?.rootKeyUrl}
            />
          </div>
        );
      case 'scorm':
      case 'xapi':
        return (
          <div className="player-wrapper">
            <ScormXapiViewer src={detail?.rootKeyUrl} />
          </div>
        );
      case 'mp3':
      case 'audio':

        return <CustomAudioPlayer
          url={detail?.rootKeyUrl}
        />;
      case 'text':
        return <div className="p-24px" contentEditable='true' dangerouslySetInnerHTML={{ __html: detail?.documentText || detail?.text }} />
      default:
        return ""
    }
  }
  if (loading) return <div className="learning-material-detail-loading">
    <Spin ></Spin>
  </div>
  return (
    <div className='learning-material-detail'>
      <div className='learning-material-detail__content'>
        <div className='flex align-center justify-between'>
          <div className="flex gap-8">
            <ArrowLeftOutlined
              style={{ width: "24px", height: "24px" }}
              onClick={() => {
                confirmNavigation({ link: '' }, false, () => {
                  navigate(-1);
                });
              }}
            />
            <Breadcrumb
              items={[
                {
                  title: t('Chi tiết học liệu', 'Chi tiết học liệu'),
                },
                {
                  title: <div className="name">
                    {detail?.name}
                  </div>,
                },
              ]}
            />
          </div>
          <div
            className='view-toggle-header pointer'
            onClick={() => setShowInfo(!showInfo)}
          >
            <InfoCircleOutlined className={`${showInfo ? "view-toggle-btn-choose" : "view-toggle-btn"}`} />
          </div>
        </div>
        <div className='view-detail'>
          {RenderDetail(detail?.unitModule)}
        </div>


      </div>
      <div className={`view-toggle ${showInfo ? 'show' : 'hide'}`}>
        {showInfo && (
          <div className='view-toggle-body'>
            <div className="flex justify-between">
              <div>{t('Chi tiết học liệu', 'Chi tiết học liệu')}</div>
              <div
                className='view-toggle-header pointer'
                onClick={() => setShowInfo(!showInfo)}
              >
                {!showInfo ? <InfoCircleOutlined className="view-toggle-btn" /> : <CloseOutlined className="view-toggle-btn" />}
              </div>
            </div>
            <div className="hr-tag-item"></div>
            <div className="info-row">
              <div className="label">{t("Tên học liệu", "Tên học liệu")}</div>
              <div className="value">{detail?.name || "-"}</div>
            </div>
            <div className="info-row">
              <div className="label">{t("Người tạo", "Người tạo")}</div>
              <div className="value">
                {detail?.createdByName || "-"} / {detail?.enterpriseName || "-"}
              </div>
            </div>
            <div className="info-row">
              <div className="label">{t("Ngày tạo", "Ngày tạo")}</div>
              <div className="value">
                {dayjs(detail?.createdDate).format("HH:mm DD/MM/YYYY")}
              </div>
            </div>
            <div className="info-row">
              <div className="label">{t("Ngày sửa đổi lần cuối", "Ngày sửa đổi lần cuối")}</div>
              <div className="value">
                {dayjs(detail?.updatedDate).format("HH:mm DD/MM/YYYY")}
              </div>
            </div>
          </div>
        )}


      </div>
    </div>
  )
}

export default LearningMaterialDetail